import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBar, Avatar, Box, Button, Divider, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import useAuth from '../../hooks/useAuth';
import useTenant from '../../hooks/useTenant';
import { getImpersonado } from '../../utils/impersonation';
import { DRAWER_WIDTH, iniciais } from '../sidebar/Sidebar';
import LanguageMenu from './LanguageMenu';

export default function Header({ onMenuToggle }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { roleTenant } = useTenant();
  const [anchorEl, setAnchorEl] = useState(null);
  const imp = getImpersonado();

  const nome = imp?.nome || user?.nome;
  const papel = imp ? t(imp.tipo === 'jurado' ? 'Judge' : 'Producer') : roleTenant ? t(roleTenant) : '';

  const fecharEIr = (acao) => () => {
    setAnchorEl(null);
    acao();
  };

  const handleSair = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <AppBar
      position="fixed"
      color="inherit"
      sx={{
        width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
        ml: { md: `${DRAWER_WIDTH}px` },
        bgcolor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <Toolbar sx={{ px: { xs: 1, sm: 2 }, gap: 1 }}>
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuToggle}
          aria-label={t('Menu')}
          sx={{ display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <LanguageMenu />

        {user && (
          <>
            <Button
              onClick={(e) => setAnchorEl(e.currentTarget)}
              color="primary"
              variant="text"
              endIcon={<KeyboardArrowDownIcon />}
              sx={{ color: 'text.primary', minWidth: 0 }}
            >
              <Avatar
                src={imp ? undefined : user.imageUrl || undefined}
                sx={{
                  width: 32,
                  height: 32,
                  mr: { sm: 1 },
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  fontSize: 13,
                }}
              >
                {iniciais(nome) || 'U'}
              </Avatar>
              <Box sx={{ textAlign: 'left', display: { xs: 'none', sm: 'block' }, maxWidth: 180 }}>
                <Typography variant="subtitle2" lineHeight={1.2} noWrap>
                  {nome}
                </Typography>
                {papel && (
                  <Typography variant="caption" color="text.secondary" noWrap component="div">
                    {papel}
                  </Typography>
                )}
              </Box>
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              PaperProps={{ sx: { width: 220, mt: 1 } }}
            >
              <Box sx={{ px: 2, py: 1.5 }}>
                <Typography variant="subtitle2" noWrap>
                  {user.nome}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap component="div">
                  {user.email}
                </Typography>
              </Box>
              <Divider />
              <MenuItem onClick={fecharEIr(() => navigate(`/perfil/detalhe/${user.clerkUserId}`))}>
                <PersonIcon fontSize="small" sx={{ mr: 1.5, color: 'text.secondary' }} />
                {t('Profile')}
              </MenuItem>
              <Divider />
              <MenuItem onClick={fecharEIr(handleSair)}>
                <LogoutIcon fontSize="small" sx={{ mr: 1.5, color: 'error.main' }} />
                <Typography color="error.main">{t('Logout')}</Typography>
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}
